import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const apiRequest = async (endpoint, options = {}) => {
  const config = {
    method: options.method || 'GET',
    url: `${API}/api${endpoint}`,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };

  if (options.body) {
    // Parse the JSON string back to object for axios
    config.data = JSON.parse(options.body);
  }

  const response = await axios(config);
  return response.data;
};

const adminAPI = {
  // System Settings
  getSystemSettings: async () => {
    return await apiRequest('/admin/settings');
  },

  updateSystemSettings: async (settings) => {
    return await apiRequest('/admin/settings', {
      method: 'PUT',
      body: JSON.stringify(settings)
    });
  },

  // Staff Management
  getAllStaff: async () => {
    return await apiRequest('/admin/staff');
  },

  createStaff: async (staffData) => {
    return await apiRequest('/admin/staff', {
      method: 'POST',
      body: JSON.stringify(staffData)
    });
  },

  updateStaff: async (staffId, staffData) => {
    return await apiRequest(`/admin/staff/${staffId}`, {
      method: 'PUT',
      body: JSON.stringify(staffData)
    });
  },

  deleteStaff: async (staffId) => {
    return await apiRequest(`/admin/staff/${staffId}`, {
      method: 'DELETE'
    });
  },

  // Payment audit — fetches the full Pocket Pay webhook ledger for a
  // single booking. Used by the BookingCard "Payment Audit" panel,
  // which lazy-fetches only when the admin expands the section.
  getBookingPaymentCallbacks: async (bookingId) => {
    return await apiRequest(`/admin/bookings/${bookingId}/payment-callbacks`);
  }
};

export default adminAPI;
